import type { BaseTextThemeOptions } from '../../../types/themed/base-text-theme-options';

import { omitUndefined } from './omit-undefined';

export function generateTextStyle(text: BaseTextThemeOptions) {
  return omitUndefined({
    fontFamily: text.fontFamily,
    fontSize: text.fontSize,
    fontStyle: text.fontStyle,
    lineHeight: text.lineHeight,
    textDecorationLine: text.textDecorationLine,
    textTransform: text.textTransform,
    fontWeight: text.fontWeight,
  });
}
